export const LABEL_TRANSLATION_MAP = {
  bonus_cashback: 'key.bonus_cashback',
  bonus_manager: 'key.bonus_manager',
  bonus_achievement: 'key.bonus_achievement',
  bonus_promocode: 'key.bonus_promocode',
} as const;
